export enum AgentScheduleExtraDataRequestType {
  REPEATED = "REPEATED",
  RECURRING = "RECURRING",
  INDIVIDUAL = "INDIVIDUAL",
}
